import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { fromJS } from 'immutable';
import validator from 'validator';
import { uniqueId } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import * as _ from 'lodash';

import injectReducer from 'utils/injectReducer';
import { removeTimeZoneFromDate } from 'utils/dateUtil';
import { makeSelectStepPersonalItems, makeSelectStepPersonalItemsErrors } from './selectors';
import reducer from './reducer';
import messages from './messages';

import { Button } from '../components/Button';
import PageSectionHeader from '../components/PageSectionHeader';
import FlexBox from '../../../components/FlexBox';
import {
  ErrorMessage,
  Validate,
  ValidateGroup,
} from '../../../components/Validation';
import {
  handleFormDataChange,
  nextSlide,
  resetDamagedLostExpenseFormData,
  resetDelayedExpenseFormData,
  resetFormCompensationExpense,
} from './actions';
import DatePicker from '../components/DatePicker/index';
import TimePickerInput from '../../../components/TimePickerInput';
import Textbox from '../components/Textbox';
import TextArea from '../components/TextArea';
import OptionsContainer from '../components/OptionsContainer';
import { CLAIMING_FOR, REPORT_TO } from './constants';
import { AdditionalList } from './components/Additional';
import { required } from '../../../utils/validation/validator';
import { saveFormData } from '../actions';
import groupOption from '../../../components/Validation/groupOption';
import { makeSelectCurrentStep } from '../../Wizard/selectors';
import AsyncButton from '../../../components/AsyncButton/index';
import { makeSelectProgressBarStatus } from '../../ProgressBar/selectors';
import HelpText from '../../../components/HelpText';
import { stepPersonalItemsExpenseLookup } from '../../FastCover/dataMapper/claimCodeMapper';
import CurrencySelector from '../components/CurrencySelector';


export class StepPersonalItems extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      validationCounter: 0,
      errors: [],
    };
    this.validatorGroup = new ValidateGroup();
    this.handleNext = this.handleNext.bind(this);
    this.checkFormError = this.checkFormError.bind(this);
    this.onResize = this.onResize.bind(this);

    this.saveButtonId = uniqueId();
    this.clickedItemId = '';
    this.nextButton = null;
  }

  componentWillReceiveProps(nextProps) {
    const { currentStep, step, stepName } = this.props;
    if ((stepName && nextProps.validateStep === stepName) || (currentStep !== nextProps.currentStep && currentStep === step)) {
      this.checkFormError();
    }

    if (this.props.isReadOnly && nextProps.errors !== this.props.errors) {
      this.state.validationCounter += 1;
      this.validatorGroup.checkValidation();
    }

    if (!nextProps.loading) {
      this.clickedItemId = '';
    }
  }

  onChange = (propertyName) => (event) => {
    if (event === null) {
      this.props.onFormDataChange(propertyName, null);
      return;
    }

    if (event.constructor.name === 'Moment') {
      this.props.onFormDataChange(propertyName, removeTimeZoneFromDate(event.toDate().toString()));
    } else {
      const target = event.target;
      const value = target.type === 'checkbox' ? target.checked : target.value;
      if (target.type === 'radio') {
        this.props.adjust();
      }
      this.props.onFormDataChange(propertyName, value);
    }
    // this.props.makeDirty(6);
  };

  onAdditionalItemsChange = (data) => {
    this.props.onFormDataChange('form.additionalItems', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onDelayedLuggageExpensesChange = (data) => {
    this.props.onFormDataChange('form.delayedLuggageExpenses', fromJS(data));
    const { adjust } = this.props;
    if (adjust) adjust();
  };

  onInputComponentChange = (propertyName) => (event) => {
    if (event.target.checked) {
      const selectedValue = this.getSelectedClaiming();
      if (!!selectedValue && selectedValue !== propertyName) {
        this.props.onFormDataChange(`form.${selectedValue}`, 'false');
      }
    }
    this.onChange(`form.${propertyName}`)(event);
    // this.props.makeDirty(6);
  };

  onResize = () => {
    const { adjust } = this.props;
    if (adjust) {
      adjust();
    }
  };

  getSelectedClaiming = () => {
    const {
      claimForPassportCreditCard,
      claimForTheftOfCash,
      claimForLuggageAndPersonalEffect,
    } = this.props.form;

    let selectedValue = null;

    switch ('true') {
      case claimForPassportCreditCard:
        selectedValue = CLAIMING_FOR.PASSPORT_CREDIT_CARD;
        break;
      case claimForTheftOfCash:
        selectedValue = CLAIMING_FOR.THEFT_OF_CASH;
        break;
      case claimForLuggageAndPersonalEffect:
        selectedValue = CLAIMING_FOR.LUGGAGE_AND_PERSONAL_EFFECTS;
        break;
      default:
        selectedValue = null;
        break;
    }

    return selectedValue;
  };

  getValidationErrors() {
    const {
      claimForDamagedLostOrStolenLuggageTravelDocumentOrCash,
      claimForDelayLuggage,
      additionalItems,
      delayedLuggageExpenses,
    } = this.props.form;
    const errors = [];

    if (claimForDamagedLostOrStolenLuggageTravelDocumentOrCash === 'true') {
      if (this.validateTableField(additionalItems)) {
        errors.push({
          field: 'additionalItems',
          message: 'Expense table fields are mandatory fields.',
        });
      }
    }

    if (claimForDelayLuggage === 'true') {
      if (this.validateTableField(delayedLuggageExpenses)) {
        errors.push({
          field: 'delayedLuggageExpenses',
          message: 'Delayed Luggage Expenses table fields are required fields.',
        });
      }
    }

    return errors;
  }

  shouldDisable = (field) => {
    const selectedValue = this.getSelectedClaiming();

    return !!selectedValue && selectedValue !== field;
  };

  appendIds = (array) =>
    array.map((item) => {
      let newItem = item; // eslint-disable-line
      if (!item.id) {
        newItem.id = new Date().getTime().toString();
      }
      return newItem;
    });

  validateTableField(groups) {
    const invalid = _.some(groups, (fields) =>
      _.some(fields, (value) => {
        const newValue = value ? value.toString() : '';
        return validator.isEmpty(newValue);
      })
    );
    return invalid;
  }

  handleKeyDown = (e) => {
    if (e.shiftKey && e.key === 'Tab') {
      return;
    }
    if (e.key === 'Tab') {
      e.preventDefault();
    }
  };

  handleSaveButtonClick = (event) => {
    const target = event.currentTarget || event.srcElement;
    this.clickedItemId = target.id;
    this.props.onFormDataSave();
    this.nextButton.focus();
  };

  showSpinnerForElement = (elementId) => this.clickedItemId === elementId;

  checkFormError() {
    const valid = this.validatorGroup.checkValidation();
    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }
  }

  handleChange = (propertyName) => (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    this.props.onFormDataChange(propertyName, value);
  };

  handleNext = () => {
    const { submitted } = this.props;
    if (submitted) {
      this.props.next();
      return;
    }

    // const errors = this.validatorGroup.getErrors();
    const valid = this.validatorGroup.checkValidation();

    this.props.onNext(!valid);
    if (!valid) {
      this.props.makeError(this.props.step);
      const counter = this.state.validationCounter + 1;
      this.setState({ validationCounter: counter });
    } else {
      this.props.makeValid(this.props.step);
    }

    this.props.onFormDataSave();
    this.props.next();
  };

  handleFormDataSave = () => {
    this.props.onFormDataSave();
  };

  handleDayChange = (propertyName) => (day) => {
    const dayWithoutTimeZone = removeTimeZoneFromDate(day);
    this.props.onFormDataChange(propertyName, dayWithoutTimeZone);
    // this.props.makeDirty(6);
  };

  summaryFormValue() {
    return _.mapValues(this.props.form, (prop) => prop || 'N/A');
  }

  renderClaimForOption() {
    const {
      claimForDamagedLostOrStolenLuggageTravelDocumentOrCash,
    } = this.props.form;

    return (
      claimForDamagedLostOrStolenLuggageTravelDocumentOrCash === 'true' &&
      this.renderClaimForForm()
    );
  }


  renderClaimForForm() {
    const { isSummary, submitted } = this.props;

    const {
      whereYouWereInRelationToTheItem,
      additional,
      claimingFor,
      whoDidYouReportThisTo,
      otherDescription,
      reportReferenceNumber,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const isReadOnly = submitted || isSummary;
    return (
      // selectedClaiming &&
      <div className="mb-4 ml-4">
        <div className="row">
          <div className="form-group col">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="areYouClaimingFor"
              group={this.validatorGroup}
              validators={[required]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={groupOption(claimingFor)}
              fieldName={messages.areYouClaimingFor}
              onChangeValueKeys={[groupOption(claimingFor)]}
            >
              <FlexBox direction="column">
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="loss"
                    checked={claimingFor.loss === true}
                    onChange={this.onChange('form.claimingFor.loss')}
                  />
                  <span>
                    <FormattedMessage {...messages.loss} />
                  </span>
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="theft"
                    checked={claimingFor.theft === true}
                    onChange={this.onChange('form.claimingFor.theft')}
                  />
                  <span>
                    <FormattedMessage {...messages.theft} />
                  </span>
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="damage"
                    checked={claimingFor.damage === true}
                    onChange={this.onChange('form.claimingFor.damage')}
                  />
                  <span>
                    <FormattedMessage {...messages.damage} />
                  </span>
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="checkbox"
                    name="delay"
                    checked={claimingFor.delay === true}
                    onChange={this.onChange('form.claimingFor.delay')}
                  />
                  <span>
                    <FormattedMessage {...messages.delay} />
                  </span>
                </OptionsContainer>
              </FlexBox>
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.areYouClaimingFor}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>


        <div className="row">
          <div className="form-group col">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="whereYouWereInRelationToTheItem"
              group={this.validatorGroup}
              validators={[required]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={whereYouWereInRelationToTheItem}
              fieldName={messages.whereYouWereInRelationToTheItem}
            >
              <TextArea
                disabled={isReadOnly}
                name="whereYouWereInRelationToTheItem"
                type="text"
                onChange={this.handleChange(
                  'form.whereYouWereInRelationToTheItem'
                )}
                value={whereYouWereInRelationToTheItem}
                isSummary={isSummary}
              />
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.whereYouWereInRelationToTheItem}
                />
              </ErrorMessage>
            </Validate>
          </div>
        </div>

        <div className="row">
          <div className="form-group col">
            <PageSectionHeader>
              <FormattedMessage {...messages.anyThingAdditionalToAdd} />
            </PageSectionHeader>
            <TextArea
              disabled={isReadOnly}
              name="additional"
              type="text"
              onChange={this.handleChange('form.additional')}
              value={additional}
              isSummary={isSummary}
            />
          </div>
        </div>


        <div className="row">
          <div className="form-group col-md-6">
            <Validate
              validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
              name="whoDidYouReportThisTo"
              group={this.validatorGroup}
              validators={[required]}
              addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
              validChangeInGroup={this.validatorGroup.validChangeInGroup}
              validationCounter={this.state.validationCounter}
              defaultValue={whoDidYouReportThisTo}
              fieldName={messages.whoDidYouReportThisTo}
            >
              <div className="row">
                <div className="col-sm-6">
                  <FlexBox direction="column">
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        checked={whoDidYouReportThisTo === REPORT_TO.POLICE}
                        onChange={this.onChange('form.whoDidYouReportThisTo')}
                        value={REPORT_TO.POLICE}
                      />
                      <FormattedMessage {...messages.police} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        checked={
                          whoDidYouReportThisTo === REPORT_TO.HOTEL_MANAGEMENT
                        }
                        onChange={this.onChange('form.whoDidYouReportThisTo')}
                        value={REPORT_TO.HOTEL_MANAGEMENT}
                      />
                      <FormattedMessage {...messages.hotelManagement} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        checked={
                          whoDidYouReportThisTo === REPORT_TO.CRUISE_SHIP
                        }
                        onChange={this.onChange('form.whoDidYouReportThisTo')}
                        value={REPORT_TO.CRUISE_SHIP}
                      />
                      <FormattedMessage {...messages.cruiseShip} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        checked={whoDidYouReportThisTo === REPORT_TO.AIRLINE}
                        onChange={this.onChange('form.whoDidYouReportThisTo')}
                        value={REPORT_TO.AIRLINE}
                      />
                      <FormattedMessage {...messages.airline} />
                    </OptionsContainer>
                  </FlexBox>
                </div>
                <div className="col-sm-6">
                  <FlexBox direction="column">
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        checked={whoDidYouReportThisTo === REPORT_TO.TOUR_GUIDE}
                        onChange={this.onChange('form.whoDidYouReportThisTo')}
                        value={REPORT_TO.TOUR_GUIDE}
                      />
                      <FormattedMessage {...messages.tourGuide} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        checked={whoDidYouReportThisTo === REPORT_TO.OTHER}
                        onChange={this.onChange('form.whoDidYouReportThisTo')}
                        value={REPORT_TO.OTHER}
                      />
                      <FormattedMessage {...messages.other} />
                    </OptionsContainer>
                    <OptionsContainer>
                      <input
                        disabled={isReadOnly}
                        type="radio"
                        checked={whoDidYouReportThisTo === REPORT_TO.NOT_REPORT}
                        onChange={this.onChange('form.whoDidYouReportThisTo')}
                        value={REPORT_TO.NOT_REPORT}
                      />
                      <FormattedMessage {...messages.notReported} />
                    </OptionsContainer>
                  </FlexBox>
                </div>
              </div>
              <ErrorMessage for="required">
                <FormattedMessage
                  {...messages.isRequired}
                  values={messages.whoDidYouReportThisTo}
                />
              </ErrorMessage>
            </Validate>
          </div>
          <div className="form-group col-md-6">
            <PageSectionHeader>
              <FormattedMessage {...messages.otherDescription} />
            </PageSectionHeader>
            <TextArea
              disabled={isReadOnly}
              name="otherDescription"
              type="text"
              onChange={this.handleChange('form.otherDescription')}
              value={otherDescription}
              isSummary={isSummary}
            />
          </div>
        </div>

        <div className="row">
          <div className="form-group col-sm-6">
            <div>
              <PageSectionHeader>
                <FormattedMessage {...messages.reportReferenceNumber} />
              </PageSectionHeader>
              <Textbox
                disabled={isReadOnly}
                name="reportReferenceNumber"
                type="text"
                onChange={this.handleChange('form.reportReferenceNumber')}
                value={reportReferenceNumber}
              />
            </div>
          </div>
        </div>

        {this.renderAdditionalItems()}
      </div>
    );
  }

  renderAdditionalItems() {
    const { additionalItems } = this.props.form;
    const newAdditionalItems = this.appendIds(additionalItems);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div>
        <PageSectionHeader>
          <FormattedMessage {...messages.additionalItem} />
        </PageSectionHeader>
        <AdditionalList
          data={newAdditionalItems}
          onChange={this.onAdditionalItemsChange}
          isDelayed={false}
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
        {/* <ErrorMessage for="required">Expense table fields are mandatory fields.</ErrorMessage> */}
        {/* </Validate> */}
      </div>
    );
  }

  renderDelayedLuggageExpenseItems() {
    const { delayedLuggageExpenses } = this.props.form;
    const newDelayedLuggageExpenses = this.appendIds(delayedLuggageExpenses);
    const { isSummary, submitted } = this.props;
    const isReadOnly = submitted || isSummary;

    return (
      <div className="mb-4">
        <PageSectionHeader>
          <FormattedMessage {...messages.delayedLuggageExpenses} />
        </PageSectionHeader>
        <AdditionalList
          data={newDelayedLuggageExpenses}
          onChange={this.onDelayedLuggageExpensesChange}
          isDelayed
          disabled={isReadOnly}
          validatorGroup={this.validatorGroup}
          validationCounter={this.state.validationCounter}
        />
      </div>
    );
  }

  renderDelayLuggageForm() {
    const { isSummary, submitted, onResetCompensationExpense } = this.props;
    const {
      claimForDelayLuggage,
      nameOfTransportProvider,
      dateLuggageDelay,
      timeLuggageDelay,
      dateLuggageReturn,
      timeLuggageReturn,
      paidForDelay,
      madeClaimWithTravelProviderOrOther,
      listedOnThePolicy,
      dateCompensationWasReceived,
      compensationDescription,
      amountOfCompensation,
      amountOfCompensationCurrency,
    } = isSummary ? this.summaryFormValue() : this.props.form;
    const isReadOnly = submitted || isSummary;

    const newTimeLuggageDelayed = timeLuggageDelay
      ? moment(timeLuggageDelay)
      : null;
    const newTimeLuggageReturned = timeLuggageReturn
      ? moment(timeLuggageReturn)
      : null;

    return (
      claimForDelayLuggage === 'true' && (
        <div className="mb-4 ml-4">
          <div className="row">
            <div className="form-group col-sm-6">
              <Validate
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                name="nameOfTransportProvider"
                group={this.validatorGroup}
                validators={[required]}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                defaultValue={nameOfTransportProvider}
                fieldName={messages.nameOfTransportProvider}
              >
                <Textbox
                  disabled={isReadOnly}
                  name="nameOfTransportProvider"
                  type="text"
                  onChange={this.handleChange('form.nameOfTransportProvider')}
                  value={nameOfTransportProvider}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.nameOfTransportProvider}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>

          <div className="row">
            <div className="form-group col-sm-6">
              <Validate
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                name="dateLuggageDelay"
                group={this.validatorGroup}
                validators={[required]}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                defaultValue={dateLuggageDelay}
                fieldName={messages.dateWhenYourLuggageWasDelayed}
              >
                <DatePicker
                  position={'bottom-start'}
                  disabled={isReadOnly}
                  name="dateLuggageDelay"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateLuggageDelay')}
                  value={dateLuggageDelay}
                  placeholder=""
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.dateWhenYourLuggageWasDelayed}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className="form-group col-sm-6">
              <Validate
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                name="timeLuggageDelay"
                group={this.validatorGroup}
                validators={[required]}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                defaultValue={newTimeLuggageDelayed}
                fieldName={messages.timeWhenYourLuggageWasDelayed}
              >
                <TimePickerInput
                  allowEmpty
                  showSecond={false}
                  onChange={this.onChange('form.timeLuggageDelay')}
                  value={newTimeLuggageDelayed}
                  disabled={isReadOnly}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.timeWhenYourLuggageWasDelayed}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>

          <div className="row">
            <div className="form-group col-sm-6">
              <Validate
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                name="dateLuggageReturn"
                group={this.validatorGroup}
                validators={[required]}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                defaultValue={dateLuggageReturn}
                fieldName={messages.dateWhenYourLuggageWasReturned}
              >
                <DatePicker
                  name="dateLuggageReturn"
                  type="text"
                  onDayChange={this.handleDayChange('form.dateLuggageReturn')}
                  value={dateLuggageReturn}
                  placeholder=""
                  disabled={isReadOnly}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.dateWhenYourLuggageWasReturned}
                  />
                </ErrorMessage>
              </Validate>
            </div>
            <div className="form-group col-sm-6">
              <Validate
                validatorLeaveGroup={this.validatorGroup.removeValidatorToGroup}
                name="timeLuggageReturn"
                group={this.validatorGroup}
                validators={[required]}
                addValidatorToGroup={this.validatorGroup.addValidatorToGroup}
                validChangeInGroup={this.validatorGroup.validChangeInGroup}
                validationCounter={this.state.validationCounter}
                defaultValue={newTimeLuggageReturned}
                fieldName={messages.timeWhenYourLuggageWasReturned}
              >
                <TimePickerInput
                  allowEmpty
                  showSecond={false}
                  onChange={this.onChange('form.timeLuggageReturn')}
                  value={newTimeLuggageReturned}
                  disabled={isReadOnly}
                />
                <ErrorMessage for="required">
                  <FormattedMessage
                    {...messages.isRequired}
                    values={messages.timeWhenYourLuggageWasReturned}
                  />
                </ErrorMessage>
              </Validate>
            </div>
          </div>

          <div className="row">
            <div className="form-group col">
              <PageSectionHeader>
                <FormattedMessage {...messages.paidForDelay} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    checked={paidForDelay === 'true'}
                    onChange={this.onChange('form.paidForDelay')}
                    value="true"
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    checked={paidForDelay === 'false'}
                    onChange={this.onChange('form.paidForDelay')}
                    value="false"
                    onClick={onResetCompensationExpense}
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>

          {paidForDelay === 'true' && (
            <div className={'ml-4'}>
              <div className="row">
                <div className="form-group col-sm-4 mb02">
                  <PageSectionHeader>
                    <FormattedMessage
                      {...messages.dateCompensationWasReceived}
                    />
                  </PageSectionHeader>
                  <DatePicker
                    disabled={isReadOnly}
                    type="text"
                    onDayChange={this.handleDayChange(
                      'form.dateCompensationWasReceived'
                    )}
                    value={dateCompensationWasReceived}
                    placeholder="dd/mm/yyyy"
                  />
                </div>
                <div className="form-group col-sm-4 mb02">
                  <PageSectionHeader>
                    <FormattedMessage {...messages.amountOfCompensation} />
                  </PageSectionHeader>
                  <Textbox
                    disabled={isReadOnly}
                    name="amountOfCompensation"
                    type="number"
                    value={amountOfCompensation}
                    onChange={this.onChange('form.amountOfCompensation')}
                  />
                </div>
                <div className="form-group col-sm-4 mb02">
                  <PageSectionHeader>
                    <FormattedMessage
                      {...messages.amountOfCompensationCurrency}
                    />
                  </PageSectionHeader>
                  <CurrencySelector
                    name="amountOfCompensationCurrency"
                    onChange={(value) => { this.props.onFormDataChange('form.amountOfCompensationCurrency', value); }}
                    disabled={isReadOnly}
                    value={amountOfCompensationCurrency}
                  />
                  <HelpText>
                    <FormattedMessage {...messages.currencyEg} />
                  </HelpText>
                </div>

              </div>
              <div className="row">
                <div className="form-group col-sm-12">
                  <PageSectionHeader>
                    <FormattedMessage {...messages.compensationDescription} />
                  </PageSectionHeader>
                  <Textbox
                    disabled={isReadOnly}
                    name="compensationDescription"
                    value={compensationDescription}
                    onChange={this.onChange('form.compensationDescription')}
                  />
                </div>
              </div>
            </div>
          )}

          <div className="row">
            <div className="form-group col">
              <PageSectionHeader className="pr-forPrint">
                <FormattedMessage
                  {...messages.madeClaimWithTravelProviderOrOther}
                />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    checked={madeClaimWithTravelProviderOrOther === 'true'}
                    onChange={this.onChange(
                      'form.madeClaimWithTravelProviderOrOther'
                    )}
                    value="true"
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    checked={madeClaimWithTravelProviderOrOther === 'false'}
                    onChange={this.onChange(
                      'form.madeClaimWithTravelProviderOrOther'
                    )}
                    value="false"
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>

          <div className="row">
            <div className="form-group col">
              <PageSectionHeader className="pr-forPrint">
                <FormattedMessage {...messages.listedOnThePolicy} />
              </PageSectionHeader>
              <FlexBox>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    checked={listedOnThePolicy === 'true'}
                    onChange={this.onChange('form.listedOnThePolicy')}
                    value="true"
                  />
                  <FormattedMessage {...messages.yes} />
                </OptionsContainer>
                <OptionsContainer>
                  <input
                    disabled={isReadOnly}
                    type="radio"
                    checked={listedOnThePolicy === 'false'}
                    onChange={this.onChange('form.listedOnThePolicy')}
                    value="false"
                  />
                  <FormattedMessage {...messages.no} />
                </OptionsContainer>
              </FlexBox>
            </div>
          </div>

          {this.renderDelayedLuggageExpenseItems()}
        </div>
      )
    );
  }

  render() {
    const {
      claimForDamagedLostOrStolenLuggageTravelDocumentOrCash,
      claimForDelayLuggage,
    } = this.props.form;
    const { isSummary, submitted, loading } = this.props;

    const isReadOnly = submitted || isSummary;
    const isRenderClaimForLuggageAndPersonalEffect = !!stepPersonalItemsExpenseLookup.claimForLuggageAndPersonalEffect.claimCode;
    const isRenderclaimForDelayLuggage = !!stepPersonalItemsExpenseLookup.claimForDelayLuggage.claimCode;
    return (
      <div className="app-content">
        {isRenderClaimForLuggageAndPersonalEffect && <div className="row">
          <div className="form-group col">
            <PageSectionHeader>
              <FormattedMessage
                {...messages.areYouClaimingForDamagedLostOrStolenLugageTravelDocumentsOrCash}
              />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={
                    claimForDamagedLostOrStolenLuggageTravelDocumentOrCash ===
                    'true'
                  }
                  onChange={this.onChange(
                    'form.claimForDamagedLostOrStolenLuggageTravelDocumentOrCash'
                  )}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={
                    claimForDamagedLostOrStolenLuggageTravelDocumentOrCash ===
                    'false'
                  }
                  onChange={this.onChange(
                    'form.claimForDamagedLostOrStolenLuggageTravelDocumentOrCash'
                  )}
                  onClick={this.props.onResetDamagedLostExpense}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
          </div>
        }
        {isRenderClaimForLuggageAndPersonalEffect && this.renderClaimForOption()}

        {isRenderclaimForDelayLuggage && <div className="row">
          <div className="form-group col">
            <PageSectionHeader>
              <FormattedMessage {...messages.areYouClaimingForDelayedLuggage} />
            </PageSectionHeader>
            <FlexBox>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={claimForDelayLuggage === 'true'}
                  onChange={this.onChange('form.claimForDelayLuggage')}
                  value="true"
                />
                <FormattedMessage {...messages.yes} />
              </OptionsContainer>
              <OptionsContainer>
                <input
                  disabled={isReadOnly}
                  type="radio"
                  checked={claimForDelayLuggage === 'false'}
                  onChange={this.onChange('form.claimForDelayLuggage')}
                  onClick={this.props.onResetDelayedExpense}
                  value="false"
                />
                <FormattedMessage {...messages.no} />
              </OptionsContainer>
            </FlexBox>
          </div>
        </div>
        }

        {isRenderclaimForDelayLuggage && this.renderDelayLuggageForm()}

        {!isSummary && (
          <div className={'row justify-content-between'}>
            <div className={'col-12 col-sm-auto'}>
              <div className={'row'}>
                <div className={'col-12 col-sm-auto'}>
                  <button
                    className="btn-outline"
                    onClick={this.props.prev}
                    onKeyDown={this.handleKeyDown}
                  >
                    Back
                  </button>
                </div>
                <div className={'col-12 col-sm-auto'}>
                  <Button
                    onClick={this.handleNext}
                    onKeyDown={this.handleKeyDown}
                    innerRef={(ref) => {
                      this.nextButton = ref;
                    }}
                  >
                    Next &gt;
                  </Button>
                </div>
              </div>
            </div>
            <div className={'col-12 col-sm-auto'}>
              {!submitted && (
                <AsyncButton
                  id={this.saveButtonId}
                  className="btn-outline"
                  loading={loading}
                  spinner={this.showSpinnerForElement(this.saveButtonId)}
                  onClick={this.handleSaveButtonClick}
                  onKeyDown={this.handleKeyDown}
                >
                  Save
                </AsyncButton>
              )}
            </div>
          </div>
        )}
        <ReactResizeDetector handleHeight onResize={this.onResize} />
      </div>
    );
  }
}

StepPersonalItems.propTypes = {
  form: PropTypes.object,
  onFormDataChange: PropTypes.func,
  prev: PropTypes.func,
  next: PropTypes.func,
  onFormDataSave: PropTypes.func,
  onResetDelayedExpense: PropTypes.func,
  onResetDamagedLostExpense: PropTypes.func,
  loading: PropTypes.bool,
  isSummary: PropTypes.bool,
  submitted: PropTypes.bool,
  adjust: PropTypes.func,
  makeValid: PropTypes.func,
  makeError: PropTypes.func,
  onNext: PropTypes.func,
  step: PropTypes.number,
  currentStep: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isReadOnly: PropTypes.bool,
  errors: PropTypes.any,
  onResetCompensationExpense: PropTypes.func,
  validateStep: PropTypes.string,
  stepName: PropTypes.string,
};

const mapStateToProps = createStructuredSelector({
  form: makeSelectStepPersonalItems(),
  errors: makeSelectStepPersonalItemsErrors(),
  currentStep: makeSelectCurrentStep(),
  loading: makeSelectProgressBarStatus(),
});

const mapDispatchToProps = (dispatch) => ({
  onFormDataChange: (propertyName, value) =>
    dispatch(handleFormDataChange(propertyName, value)),
  onFormDataSave: () => dispatch(saveFormData()),
  onNext: (errors) => dispatch(nextSlide(errors)),
  onResetDelayedExpense: () => dispatch(resetDelayedExpenseFormData()),
  onResetDamagedLostExpense: () => dispatch(resetDamagedLostExpenseFormData()),
  onResetCompensationExpense: () => dispatch(resetFormCompensationExpense()),
});

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps
);
const withReducer = injectReducer({ key: 'stepPersonalItems', reducer });

export default compose(
  withReducer,
  withConnect
)(StepPersonalItems);



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepPersonalItems/index.js